module.exports = __webpack_public_path__ + "static/colgadas-019.thumb-32b0d2b2bef488aba79d1382d95bf91a.jpg";